<mat-dialog-content>

  <div class="cart-table-container">
    <div class="container-header">
      Select a subscription payment
    </div>
  
    <table mat-table [dataSource]="data.subscription.payments">
      <ng-container matColumnDef="id">
        <th class="header-bg" mat-header-cell *matHeaderCellDef>
          REFERENCE ID
        </th>
        <td mat-cell *matCellDef="let line">
          <div  class="id-text cell-content">{{ line.serviceId }}</div>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="date">
        <th class="header-bg" mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let line">
          <div  class="cell-content">{{ line.timestamp | date:'medium' }}</div>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="amount">
        <th class="header-bg" mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let line">
          <div  class="cell-content">{{ line.amount | amount | currency }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="receipt">
        <th class="header-bg" mat-header-cell *matHeaderCellDef>Receipts</th>
        <td mat-cell *matCellDef="let line">
          <button mat-button (click)="openSimpleReceiptDialog(line)" color="primary" class="btn-details">
            Receipt
            <mat-icon iconPositionEnd>receipt_long</mat-icon>
          </button>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  
  </div>

</mat-dialog-content>

<mat-dialog-actions [align]="'end'">
  <button mat-button [mat-dialog-close]="false" cdkFocusInitial>Close</button>
</mat-dialog-actions>